import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(agro_exporter_id, agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/finances/container_incomes/show_process/${agro_exporter_id}/fetch_agro_exporter_process/${agro_exporter_process_id}`
    );
  },
  fetchContainer(agro_exporter_id, container_id) {
    return RequesterV1.get(
      `agro_exporter/finances/container_incomes/show_container/${agro_exporter_id}/fetch_container/${container_id}`
    );
  },
  fetchExportInvoices(agro_exporter_id, export_invoice_id) {
    return RequesterV1.get(
      `agro_exporter/finances/container_incomes/show_container/${agro_exporter_id}/fetch_export_invoices/${export_invoice_id}`
    );
  }
};
